export default {
  "vueform": {
    "elements": {
      "list": {
        "add": "+ 追加",
        "remove": "&times;"
      },
      "file": {
        "defaultName": "ファイル",
        "dndTitle": "ファイルをアップロードする",
        "dndDescription": "ファイルをドロップするか、ここをクリックしてアップロードしてください",
        "removeConfirm": "ファイルを削除すると、永久に削除されます。続行してもよろしいですか？",
        "select": "ファイルを選択",
        "upload": "アップロード"
      },
      "multifile": {
        "uploadButton": "ファイルのアップロード",
        "dndTitle": "ファイルのアップロード",
        "dndDescription": "ファイルをドロップするか、ここをクリックしてアップロードしてください"
      },
      "gallery": {
        "uploadButton": "画像をアップロードする",
        "dndTitle": "画像をアップロードする",
        "dndDescription": "画像をドロップするか、ここをクリックしてアップロードしてください"
      },
      "phone": {
        "ariaLabel": "国を選択"
      },
      "signature": {
        "type": "タイプする",
        "draw": "描く",
        "upload": "アップロード",
        "font": "フォントを選択",
        "fontPlaceholder": "あなたの名前",
        "placeholder": "ここにサイン",
        "unsupportedFormat": "サポートされていないファイル形式です。受け入れられる拡張子は: :extensions",
        "maxSizeError": "最大ファイルサイズは:max KBです",
        "imgAlt": "署名",
        "imgTitle": "署名",
        "undo": "元に戻す",
        "redo": "やり直し",
        "dnd": "ここに画像をドロップするか",
        "uploadButton": "画像を選択",
        "modeSelectorAriaLabel": "署名モードを選択",
        "fontSelectorAriaLabel": "フォントを選択",
        "wrapperAriaLabel": "署名入力",
        "inputAriaLabel": "ここに署名を入力",
        "padAriaLabel": "ボックスに署名を描いてください。必要に応じて支援を求めてください。",
        "clearAriaLabel": "署名をクリア",
        "colorAriaLabel": "色を選択: "
      }
    },
    "steps": {
      "finish": "終了",
      "next": "次へ",
      "previous": "前へ"
    },
    "editor": {
      "acceptedMimesError": "受け付けたマイムは次のとおりです：:mimes",
      "acceptedExtensionsError": "受け付けた拡張機能は次のとおりです：:extensions"
    },
    "datepicker": {
      "weekdays": {
        "shorthand": [
          "日",
          "月",
          "火",
          "水",
          "木",
          "金",
          "土"
        ],
        "longhand": [
          "日曜日",
          "月曜日",
          "火曜日",
          "水曜日",
          "木曜日",
          "金曜日",
          "土曜日"
        ]
      },
      "months": {
        "shorthand": [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        "longhand": [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ]
      },
      "daysInMonth": [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ],
      "firstDayOfWeek": 0,
      "ordinal": function () {
        return '';
      },
      "rangeSeparator": " から ",
      "weekAbbreviation": "Wk",
      "scrollTitle": "Scroll to increment",
      "toggleTitle": "Click to toggle",
      "amPM": [
        "午前",
        "午後"
      ],
      "yearAriaLabel": "年",
      "monthAriaLabel": "月",
      "hourAriaLabel": "時間",
      "minuteAriaLabel": "分"
    },
    "dateFormats": {
      "datetimeSeconds24": "YYYY/MM/DD HH:mm:ss",
      "datetimeSeconds12": "YYYY/MM/DD ahh:mm:ss",
      "datetime24": "YYYY/MM/DD HH:mm",
      "datetime12": "YYYY/MM/DD ahh:mm",
      "timeSeconds24": "HH:mm:ss",
      "timeSeconds12": "ahh:mm:ss",
      "time24": "HH:mm",
      "time12": "ahh:mm",
      "date": "YYYY/MM/DD"
    },
    "multiselect": {
      "multipleLabelOne": "1つのオプションが選択されました",
      "multipleLabelMore": ":options オプションが選択されました",
      "noResults": "オプションが見つかりません",
      "noOptions": "リストは空です"
    },
    "defaultMessage": "無効なフィールド",
    "a11y": {
      "file": {
        "description": "Press Backspace to remove"
      },
      "list": {
        "remove": "Remove item button"
      }
    },
    "countries": {
      "AF": "アフガニスタン",
      "AL": "アルバニア",
      "DZ": "アルジェリア",
      "AS": "アメリカンサモア",
      "AD": "アンドラ",
      "AO": "アンゴラ",
      "AI": "アンギラ",
      "AG": "アンティグア・バーブーダ",
      "AR": "アルゼンチン",
      "AM": "アルメニア",
      "AW": "アルバ",
      "AC": "アセンション島",
      "AU": "オーストラリア",
      "AT": "オーストリア",
      "AZ": "アゼルバイジャン",
      "BS": "バハマ",
      "BH": "バーレーン",
      "BD": "バングラデシュ",
      "BB": "バルバドス",
      "BY": "ベラルーシ",
      "BE": "ベルギー",
      "BZ": "ベリーズ",
      "BJ": "ベナン",
      "BM": "バミューダ",
      "BT": "ブータン",
      "BO": "ボリビア",
      "BA": "ボスニア・ヘルツェゴビナ",
      "BW": "ボツワナ",
      "BR": "ブラジル",
      "IO": "英領インド洋地域",
      "VG": "イギリス領ヴァージン諸島",
      "BN": "ブルネイ",
      "BG": "ブルガリア",
      "BF": "ブルキナファソ",
      "BI": "ブルンジ",
      "KH": "カンボジア",
      "CM": "カメルーン",
      "CA": "カナダ",
      "CV": "カーボベルデ",
      "BQ": "カリブオランダ",
      "KY": "ケイマン諸島",
      "CF": "中央アフリカ共和国",
      "TD": "チャド",
      "CL": "チリ",
      "CN": "中国",
      "CO": "コロンビア",
      "KM": "コモロ",
      "CG": "コンゴ - ブラザビル",
      "CD": "コンゴ - キンシャサ",
      "CK": "クック諸島",
      "CR": "コスタリカ",
      "CI": "コートジボワール",
      "HR": "クロアチア",
      "CU": "キューバ",
      "CW": "キュラソー",
      "CY": "キプロス",
      "CZ": "チェコ",
      "DK": "デンマーク",
      "DJ": "ジブチ",
      "DM": "ドミニカ国",
      "DO": "ドミニカ共和国",
      "EC": "エクアドル",
      "EG": "エジプト",
      "SV": "エルサルバドル",
      "GQ": "赤道ギニア",
      "ER": "エリトリア",
      "EE": "エストニア",
      "SZ": "エスワティニ",
      "ET": "エチオピア",
      "FK": "フォークランド諸島（マルビナス諸島）",
      "FO": "フェロー諸島",
      "FJ": "フィジー",
      "FI": "フィンランド",
      "FR": "フランス",
      "GF": "フランス領ギアナ",
      "PF": "フランス領ポリネシア",
      "GA": "ガボン",
      "GM": "ガンビア",
      "GE": "ジョージア",
      "DE": "ドイツ",
      "GH": "ガーナ",
      "GI": "ジブラルタル",
      "GR": "ギリシャ",
      "GL": "グリーンランド",
      "GD": "グレナダ",
      "GP": "グアドループ",
      "GU": "グアム",
      "GT": "グアテマラ",
      "GN": "ギニア",
      "GW": "ギニアビサウ",
      "GY": "ガイアナ",
      "HT": "ハイチ",
      "HN": "ホンジュラス",
      "HK": "香港",
      "HU": "ハンガリー",
      "IS": "アイスランド",
      "IN": "インド",
      "ID": "インドネシア",
      "IR": "イラン",
      "IQ": "イラク",
      "IE": "アイルランド",
      "IL": "イスラエル",
      "IT": "イタリア",
      "JM": "ジャマイカ",
      "JP": "日本",
      "JO": "ヨルダン",
      "KZ": "カザフスタン",
      "KE": "ケニア",
      "KI": "キリバス",
      "XK": "コソボ",
      "KW": "クウェート",
      "KG": "キルギス",
      "LA": "ラオス",
      "LV": "ラトビア",
      "LB": "レバノン",
      "LS": "レソト",
      "LR": "リベリア",
      "LY": "リビア",
      "LI": "リヒテンシュタイン",
      "LT": "リトアニア",
      "LU": "ルクセンブルク",
      "MO": "マカオ",
      "MG": "マダガスカル",
      "MW": "マラウイ",
      "MY": "マレーシア",
      "MV": "モルディブ",
      "ML": "マリ",
      "MT": "マルタ",
      "MH": "マーシャル諸島",
      "MQ": "マルティニーク",
      "MR": "モーリタニア",
      "MU": "モーリシャス",
      "MX": "メキシコ",
      "FM": "ミクロネシア連邦",
      "MD": "モルドバ",
      "MC": "モナコ",
      "MN": "モンゴル",
      "ME": "モンテネグロ",
      "MS": "モントセラト",
      "MA": "モロッコ",
      "MZ": "モザンビーク",
      "MM": "ミャンマー（ビルマ）",
      "NA": "ナミビア",
      "NR": "ナウル",
      "NP": "ネパール",
      "NL": "オランダ",
      "NC": "ニューカレドニア",
      "NZ": "ニュージーランド",
      "NI": "ニカラグア",
      "NE": "ニジェール",
      "NG": "ナイジェリア",
      "NU": "ニウエ",
      "NF": "ノーフォーク島",
      "KP": "北朝鮮",
      "MK": "北マケドニア",
      "MP": "北マリアナ諸島",
      "NO": "ノルウェー",
      "OM": "オマーン",
      "PK": "パキスタン",
      "PW": "パラオ",
      "PS": "パレスチナ",
      "PA": "パナマ",
      "PG": "パプアニューギニア",
      "PY": "パラグアイ",
      "PE": "ペルー",
      "PH": "フィリピン",
      "PL": "ポーランド",
      "PT": "ポルトガル",
      "PR": "プエルトリコ",
      "QA": "カタール",
      "RE": "レユニオン",
      "RO": "ルーマニア",
      "RU": "ロシア",
      "RW": "ルワンダ",
      "WS": "サモア",
      "SM": "サンマリノ",
      "ST": "サントメ・プリンシペ",
      "SA": "サウジアラビア",
      "SN": "セネガル",
      "RS": "セルビア",
      "SC": "セーシェル",
      "SL": "シエラレオネ",
      "SG": "シンガポール",
      "SX": "シント・マールテン",
      "SK": "スロバキア",
      "SI": "スロベニア",
      "SB": "ソロモン諸島",
      "SO": "ソマリア",
      "ZA": "南アフリカ",
      "KR": "韓国",
      "SS": "南スーダン",
      "ES": "スペイン",
      "LK": "スリランカ",
      "BL": "サン・バルテルミー",
      "SH": "セントヘレナ",
      "KN": "セントクリストファー・ネービス",
      "LC": "セントルシア",
      "MF": "サン・マルタン",
      "PM": "サンピエール島・ミクロン島",
      "VC": "セントビンセントおよびグレナディーン諸島",
      "SD": "スーダン",
      "SR": "スリナム",
      "SE": "スウェーデン",
      "CH": "スイス",
      "SY": "シリア",
      "TW": "台湾",
      "TJ": "タジキスタン",
      "TZ": "タンザニア",
      "TH": "タイ",
      "TL": "東ティモール",
      "TG": "トーゴ",
      "TK": "トケラウ",
      "TO": "トンガ",
      "TT": "トリニダード・トバゴ",
      "TN": "チュニジア",
      "TR": "トルコ",
      "TM": "トルクメニスタン",
      "TC": "タークス・カイコス諸島",
      "TV": "ツバル",
      "VI": "アメリカ領バージン諸島",
      "UG": "ウガンダ",
      "UA": "ウクライナ",
      "AE": "アラブ首長国連邦",
      "GB": "イギリス",
      "US": "アメリカ合衆国",
      "UY": "ウルグアイ",
      "UZ": "ウズベキスタン",
      "VU": "バヌアツ",
      "VA": "バチカン市国",
      "VE": "ベネズエラ",
      "VN": "ベトナム",
      "WF": "ウォリス・フツナ",
      "YE": "イエメン",
      "ZM": "ザンビア",
      "ZW": "ジンバブエ"
    }
  },
  "validation": {
    "accepted": ":attributeを承認してください。",
    "active_url": ":attributeは、有効なURLではありません。",
    "after": ":attributeには、:dateより後の日付を指定してください。",
    "after_or_equal": ":attributeには、:date以降の日付を指定してください。",
    "alpha": ":attributeには、アルファベッドのみ使用できます。",
    "alpha_dash": ":attributeには、英数字(A-Z,a-z,0-9)とハイフンと下線(-,_)が使用できます。",
    "alpha_num": ":attributeには、英数字(A-Z,a-z,0-9)が使用できます。",
    "array": ":attributeには、配列を指定してください。",
    "before": ":attributeには、:dateより前の日付を指定してください。",
    "before_or_equal": ":attributeには、:date以前の日付を指定してください。",
    "between": {
      "numeric": ":attributeには、:minから、:maxまでの数字を指定してください。",
      "file": ":attributeには、:min KBから:max KBまでのサイズのファイルを指定してください。",
      "string": ":attributeは、:min文字から:max文字にしてください。",
      "array": ":attributeの項目は、:min個から:max個にしてください。"
    },
    "boolean": ":attributeには、trueかfalseを指定してください。",
    "captcha": "Please verify that you are not a robot.",
    "completed": "Please fill in a valid phone number.",
    "confirmed": ":attributeと:attribute確認が一致しません。",
    "date": ":attributeは、正しい日付ではありません。",
    "date_format": ":attributeの形式は、:formatと合いません。",
    "date_equals": ":attributeは:dateに等しい日付でなければなりません。",
    "different": ":attributeと:otherには、異なるものを指定してください。",
    "digits": ":attributeは、:digits桁にしてください。",
    "digits_between": ":attributeは、:min桁から:max桁にしてください。",
    "dimensions": ":attributeの画像サイズが無効です",
    "distinct": ":attributeの値が重複しています。",
    "email": ":attributeは、有効なメールアドレス形式で指定してください。",
    "exists": "選択された:attributeは、有効ではありません。",
    "file": ":attributeはファイルでなければいけません。",
    "filled": ":attributeは必須です。",
    "gt": {
      "numeric": ":attributeは、:valueより大きくなければなりません。",
      "file": ":attributeは、:value KBより大きくなければなりません。",
      "string": ":attributeは、:value文字より大きくなければなりません。",
      "array": ":attributeの項目数は、:value個より大きくなければなりません。"
    },
    "gte": {
      "numeric": ":attributeは、:value以上でなければなりません。",
      "file": ":attributeは、:value KB以上でなければなりません。",
      "string": ":attributeは、:value文字以上でなければなりません。",
      "array": ":attributeの項目数は、:value個以上でなければなりません。"
    },
    "image": ":attributeには、画像を指定してください。",
    "in": "選択された:attributeは、有効ではありません。",
    "in_array": ":attributeが:otherに存在しません。",
    "integer": ":attributeには、整数を指定してください。",
    "ip": ":attributeには、有効なIPアドレスを指定してください。",
    "ipv4": ":attributeはIPv4アドレスを指定してください。",
    "ipv6": ":attributeはIPv6アドレスを指定してください。",
    "json": ":attributeには、有効なJSON文字列を指定してください。",
    "lt": {
      "numeric": ":attributeは、:valueより小さくなければなりません。",
      "file": ":attributeは、:value KBより小さくなければなりません。",
      "string": ":attributeは、:value文字より小さくなければなりません。",
      "array": ":attributeの項目数は、:value個より小さくなければなりません。"
    },
    "lte": {
      "numeric": ":attributeは、:value以下でなければなりません。",
      "file": ":attributeは、:value KB以下でなければなりません。",
      "string": ":attributeは、:value文字以下でなければなりません。",
      "array": ":attributeの項目数は、:value個以下でなければなりません。"
    },
    "max": {
      "numeric": ":attributeには、:max以下の数字を指定してください。",
      "file": ":attributeには、:max KB以下のファイルを指定してください。",
      "string": ":attributeは、:max文字以下にしてください。",
      "array": ":attributeの項目は、:max個以下にしてください。"
    },
    "mimes": ":attributeには、:valuesタイプのファイルを指定してください。",
    "mimetypes": ":attributeには、:valuesタイプのファイルを指定してください。",
    "min": {
      "numeric": ":attributeには、:min以上の数字を指定してください。",
      "file": ":attributeには、:min KB以上のファイルを指定してください。",
      "string": ":attributeは、:min文字以上にしてください。",
      "array": ":attributeの項目は、:min個以上にしてください。"
    },
    "not_in": "選択された:attributeは、有効ではありません。",
    "not_regex": ":attributeの形式が無効です。",
    "numeric": ":attributeには、数字を指定してください。",
    "present": "The :attribute field must be present.",
    "regex": ":attributeには、有効な正規表現を指定してください。",
    "required": ":attributeは、必ず指定してください。",
    "required_if": "The :attribute field is required when :other is :value.",
    "required_unless": "The :attribute field is required unless :other is in :values.",
    "required_with": "The :attribute field is required when :values is present.",
    "required_with_all": "The :attribute field is required when :values are present.",
    "required_without": "The :attribute field is required when :values is not present.",
    "required_without_all": "The :attribute field is required when none of :values are present.",
    "same": ":attributeと:otherが一致しません。",
    "size": {
      "numeric": ":attributeには、:sizeを指定してください。",
      "file": ":attributeには、:size KBのファイルを指定してください。",
      "string": ":attributeは、:size文字にしてください。",
      "array": ":attributeの項目は、:size個にしてください。"
    },
    "string": ":attributeには、文字を指定してください。",
    "timezone": ":attributeには、有効なタイムゾーンを指定してください。",
    "unique": "指定の:attributeは既に使用されています。",
    "uploaded": "The :attribute failed to upload.",
    "url": ":attributeは、有効なURL形式で指定してください。",
    "uuid": ":attributeは、有効なUUIDでなければなりません。",
    "remote": "The :attribute field is invalid."
  }
}